<template>
  <component :is="component" v-bind="props" @change="handleFilterChanged" />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from "vue";
import DeviceUtils from "@utils/device.utils.ts";
import { FilterAccordionProps, FilterAccordionEmits } from "@/common/filter-types.ts";

const props = defineProps<FilterAccordionProps>();
const emit = defineEmits<FilterAccordionEmits>();

// Data
const FilterAccordionDesktop = defineAsyncComponent(
  () => import("@/components/FilterAccordionDesktop.vue"),
);
const FilterAccordionMobile = defineAsyncComponent(
  () => import("@/components/FilterAccordionMobile.vue"),
);

const component =
  DeviceUtils.isDekstop() || DeviceUtils.isDesktopLarge()
    ? FilterAccordionDesktop
    : FilterAccordionMobile;

// Methods
const handleFilterChanged = (data) => {
  emit("change", data);
};
</script>
